import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";

export const CENAttributeNamesHandler: Handler = (props: any) => {
    props.dispatch({
        type: "Custom/ProductListCardList/AttributeNames",
        data: props.parameter.data,
    });
};

export const chain = [CENAttributeNamesHandler];

const cenAttributeNamesHandler = createHandlerChainRunnerOptionalParameter(chain, {}, "CENAttributeNamesHandler");
export default cenAttributeNamesHandler;
